import { render, staticRenderFns } from "./MarkdownImage.vue?vue&type=template&id=67765425&scoped=true"
import script from "./MarkdownImage.vue?vue&type=script&lang=js"
export * from "./MarkdownImage.vue?vue&type=script&lang=js"
import style0 from "./MarkdownImage.vue?vue&type=style&index=0&id=67765425&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.25_css-loader@6.11.0_webpack@5.103.0__lodash@4_398719d9ba0fb65ce1cea3b2910bec76/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67765425",
  null
  
)

export default component.exports